var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-card',{class:'main'},[_c('h1',[_vm._v(" "+_vm._s(_vm.$t( _vm.comOnly ? 'pages.how_it_works_ComOnly.title' : 'pages.how_it_works.title' ))+" ")]),_c('span',{domProps:{"innerHTML":_vm._s(
      _vm.$t(
        _vm.comOnly
          ? 'pages.how_it_works_ComOnly.body'
          : 'pages.how_it_works.body'
      )
    )}})])}
var staticRenderFns = []

export { render, staticRenderFns }